import React from "react"

const ChinhSachBaoVeDuLieuCaNhan = () => {
  return (
    <>
      <p>
        <strong>CHÍNH SÁCH BẢO VỆ DỮ LIỆU CÁ NHÂN</strong>
      </p>

      <p>
        <strong>
          <em>(Áp dụng từ ngày 21/8/2025)</em>
        </strong>
      </p>

      <p>
        <strong>1. Giới thiệu</strong>
      </p>

      <p>
        Chính sách Bảo vệ Dữ liệu cá nhân của dịch vụ ON Live TV (&quot;ON Live TV&quot;) quy định các yêu cầu nghiêm
        ngặt đối với việc xử lý dữ liệu cá nhân liên quan đến khách hàng, đối tác kinh doanh, nhân viên hoặc bất kỳ cá
        nhân nào khác. Chính sách này tuân thủ các nguyên tắc của luật bảo vệ dữ liệu quốc gia và quốc tế như đảm bảo
        tuân thủ Đạo luật Bảo vệ Dữ liệu Châu Âu.
      </p>

      <p>
        Chính sách này đặt ra một tiêu chuẩn bảo vệ và an toàn dữ liệu áp dụng toàn cầu cho ON Live TV và điều chỉnh
        việc chia sẻ thông tin giữa ON Live TV và các pháp nhân liên quan. ON Live TV đã thiết lập các nguyên tắc bảo vệ
        dữ liệu - bao gồm tính minh bạch, tiết kiệm dữ liệu và bảo mật dữ liệu - như là Chính sách Bảo vệ Dữ liệu Cá
        nhân và Hướng dẫn Quản lý An ninh Thông tin của ON Live TV.
      </p>

      <p>
        Các nhà quản lý và nhân viên của ON Live TV có nghĩa vụ tuân thủ Chính sách Bảo vệ Dữ liệu của Công ty và tuân
        thủ các luật bảo vệ dữ liệu địa phương. Là Cán bộ Bảo vệ Dữ liệu, nhiệm vụ của tôi là đảm bảo rằng các quy tắc
        và nguyên tắc bảo vệ dữ liệu tại ON Live TV được tuân thủ trên toàn thế giới.
      </p>

      <p>
        <strong>1.1. Mục đích</strong>
      </p>

      <p>
        Chính sách Bảo vệ Dữ liệu này áp dụng cho ON Live TV và dựa trên các nguyên tắc cơ bản được chấp nhận về bảo vệ
        dữ liệu. Việc đảm bảo bảo vệ dữ liệu là nền tảng của các mối quan hệ kinh doanh đáng tin cậy và danh tiếng của
        ON Live TV như một nhà cung cấp dịch vụ và nhà tuyển dụng uy tín.
      </p>

      <p>
        Chính sách Bảo vệ Dữ liệu cung cấp một trong những điều kiện khung cần thiết cho việc chuyển giao dữ liệu giữa
        ON Live TV và các pháp nhân liên quan. Chính sách này đảm bảo mức độ bảo vệ dữ liệu phù hợp theo Quy định Bảo vệ
        Dữ liệu Chung của Liên minh Châu Âu (GDPR), Luật Bảo vệ Dữ liệu Cá nhân, hoặc các quy định bảo vệ dữ liệu cá
        nhân quốc gia khác và luật quốc gia về truyền dữ liệu xuyên biên giới (nếu có), bao gồm cả các quốc gia chưa có
        luật bảo vệ dữ liệu phù hợp.
      </p>

      <p>
        Để chuẩn hóa việc thu thập, xử lý, chuyển giao và sử dụng dữ liệu cá nhân, đồng thời thúc đẩy việc sử dụng dữ
        liệu cá nhân một cách hợp lý, hợp pháp, công bằng và minh bạch nhằm ngăn chặn dữ liệu cá nhân bị đánh cắp, thay
        đổi, hủy hoại, mất mát hoặc rò rỉ, ON Live TV thiết lập chính sách quản lý bảo vệ dữ liệu cá nhân và các chính
        sách an toàn, bảo mật thông tin liên quan.
      </p>

      <p>
        <strong>1.2. Phạm vi áp dụng</strong>
      </p>

      <p>Tất cả các hoạt động xử lý dữ liệu cá nhân của ON Live TV đều nằm trong phạm vi của Chính sách này.</p>

      <p>
        Điều này có nghĩa là tất cả các quy trình kinh doanh và hệ thống thông tin của ON Live TV liên quan đến việc thu
        thập, xử lý, sử dụng và chuyển giao dữ liệu cá nhân, cũng như tất cả nhân viên, nhà thầu và nhà cung cấp bên thứ
        ba tham gia xử lý dữ liệu cá nhân thay mặt cho ON Live TV.
      </p>

      <p>
        Chính sách này có tính ràng buộc đối với tất cả các phòng ban và chức năng trên toàn cầu có liên quan đến việc
        xử lý thông tin nhận dạng cá nhân. Mọi phòng ban, pháp nhân hoặc công ty con/văn phòng đại diện của ON Live TV
        phải tuân thủ quy trình này.
      </p>

      <p>
        Phạm vi áp dụng bao gồm tất cả các chủ thể dữ liệu có dữ liệu cá nhân được thu thập, phù hợp với các yêu cầu của
        Quy định Bảo vệ Dữ liệu Chung của Liên minh Châu Âu (GDPR), Luật Bảo vệ Dữ liệu Cá nhân và các quy định bảo vệ
        dữ liệu quốc gia/quốc tế khác.
      </p>

      <p>
        <strong>1.3. Áp dụng luật quốc gia</strong>
      </p>

      <p>
        Chính sách Bảo vệ Dữ liệu này bao gồm các nguyên tắc bảo vệ dữ liệu được chấp nhận quốc tế mà không thay thế các
        luật quốc gia hiện hành. Chính sách này bổ sung cho các luật bảo vệ dữ liệu quốc gia. Luật quốc gia liên quan sẽ
        được ưu tiên áp dụng trong trường hợp có xung đột với Chính sách Bảo vệ Dữ liệu này, hoặc nếu luật đó có yêu cầu
        nghiêm ngặt hơn so với Chính sách này. Nội dung của Chính sách Bảo vệ Dữ liệu này cũng phải được tuân thủ trong
        trường hợp không có luật quốc gia tương ứng. Các yêu cầu báo cáo về xử lý dữ liệu theo luật quốc gia phải được
        tuân thủ đầy đủ.
      </p>

      <p>
        Mỗi công ty con/văn phòng đại diện hoặc pháp nhân của ON Live TV chịu trách nhiệm tuân thủ Chính sách Bảo vệ Dữ
        liệu này và các nghĩa vụ pháp lý liên quan. Nếu có cơ sở để tin rằng các nghĩa vụ pháp lý mâu thuẫn với các
        nghĩa vụ theo Chính sách Bảo vệ Dữ liệu này, công ty con/văn phòng đại diện hoặc pháp nhân liên quan phải kịp
        thời thông báo cho Cán bộ Bảo vệ Dữ liệu.
      </p>

      <p>
        Trong trường hợp phát sinh xung đột giữa luật quốc gia và Chính sách Bảo vệ Dữ liệu, ON Live TV, thông qua Cán
        bộ Bảo vệ Dữ liệu, sẽ phối hợp với công ty con/văn phòng đại diện hoặc pháp nhân liên quan để xác định và triển
        khai giải pháp thực tế phù hợp, nhằm đáp ứng mục tiêu và tinh thần của Chính sách Bảo vệ Dữ liệu.
      </p>

      <p>
        <strong>1.4. Ngăn chặn vi phạm luật bảo vệ dữ liệu quốc gia và quốc tế</strong>
      </p>

      <p>
        ON Live TV cam kết triển khai các biện pháp kỹ thuật và tổ chức phù hợp nhằm ngăn chặn, phát hiện và xử lý kịp
        thời các hành vi vi phạm quy định pháp luật về bảo vệ dữ liệu cá nhân ở cấp độ quốc gia và quốc tế. Các biện
        pháp này bao gồm, nhưng không giới hạn, việc thiết lập cơ chế quản trị dữ liệu, phân quyền truy cập, kiểm soát
        an ninh hệ thống, đánh giá rủi ro và giám sát việc tuân thủ trong toàn bộ quá trình xử lý dữ liệu cá nhân.
      </p>

      <p>
        Tất cả nhân viên, nhà thầu và bên thứ ba được ON Live TV ủy quyền xử lý dữ liệu cá nhân phải tuân thủ nghiêm
        ngặt các quy định của Chính sách Bảo vệ Dữ liệu này cũng như các luật bảo vệ dữ liệu hiện hành. Mọi hành vi xử
        lý dữ liệu cá nhân trái với quy định, vượt quá mục đích được phê duyệt hoặc không có cơ sở pháp lý hợp lệ đều bị
        nghiêm cấm.
      </p>

      <p>
        ON Live TV thiết lập quy trình tiếp nhận, báo cáo và xử lý sự cố vi phạm dữ liệu cá nhân, bao gồm các sự cố mất
        mát, truy cập trái phép, tiết lộ, thay đổi hoặc hủy hoại dữ liệu cá nhân. Trong trường hợp xảy ra vi phạm, ON
        Live TV sẽ thực hiện các biện pháp khắc phục cần thiết, đồng thời thông báo cho cơ quan quản lý nhà nước có thẩm
        quyền và các chủ thể dữ liệu liên quan theo đúng yêu cầu của pháp luật áp dụng.
      </p>

      <p>
        Việc không tuân thủ Chính sách Bảo vệ Dữ liệu này hoặc các quy định pháp luật liên quan có thể dẫn đến các biện
        pháp xử lý kỷ luật nội bộ, trách nhiệm pháp lý và các chế tài khác theo quy định của pháp luật hiện hành.
      </p>

      <p>
        <strong>2.Chính sách</strong>
      </p>

      <p>
        <strong>2.1. Nguyên tắc định hướng</strong>
      </p>

      <p>
        <strong>2.1.1 Quy tắc bảo vệ dữ liệu cá nhân</strong>
      </p>

      <p>Dữ liệu cá nhân phải được xử lý theo quy định của pháp luật.</p>

      <p>
        Chủ thể dữ liệu được thông báo về các hoạt động liên quan đến việc xử lý dữ liệu cá nhân của họ, trừ khi luật
        pháp có quy định khác.
      </p>

      <p>
        Dữ liệu cá nhân phải được xử lý cho các mục đích đã được đăng ký và khai báo bởi Bên Kiểm soát Dữ liệu, Bên xử
        lý Dữ liệu Cá nhân, Bên kiểm soát kiêm xử lý Dữ liệu và Bên thứ ba.
      </p>

      <p>
        Dữ liệu cá nhân thu thập được phải phù hợp với phạm vi và mục đích xử lý. Việc mua bán dữ liệu cá nhân bị cấm
        dưới mọi hình thức, trừ khi luật pháp có quy định khác.
      </p>

      <p>Dữ liệu cá nhân phải được cập nhật và bổ sung cho các mục đích xử lý.</p>

      <p>
        Dữ liệu cá nhân phải được bảo vệ và bảo mật trong suốt quá trình xử lý. Cụ thể, dữ liệu cá nhân phải được bảo vệ
        khỏi các vi phạm đối với quy định về bảo vệ dữ liệu cá nhân và ngăn chặn mất mát, hủy hoại hoặc thiệt hại do các
        sự cố và sử dụng các biện pháp kỹ thuật.
      </p>

      <p>
        Dữ liệu cá nhân phải được lưu trữ trong khoảng thời gian phù hợp với mục đích xử lý, trừ khi luật pháp có quy
        định khác.
      </p>

      <p>
        Bên Kiểm soát Dữ liệu và Bên Kiểm soát Dữ liệu kiêm Xử lý dữ liệu phải tuân thủ các quy tắc xử lý dữ liệu được
        quy định trong các Khoản từ 1 đến 7 của Điều này và chứng minh sự tuân thủ của mình.
      </p>

      <p>
        <strong>2.1.2 Đảm bảo quyền của chủ thể dữ liệu</strong>
      </p>

      <p>
        Quyền được thông báo: Chủ thể dữ liệu có quyền được thông báo về việc xử lý dữ liệu cá nhân của mình, trừ khi
        luật pháp có quy định khác.
      </p>

      <p>
        Quyền đồng ý: Chủ thể dữ liệu có quyền đồng ý với việc xử lý dữ liệu cá nhân của mình thông qua thiết lập kỹ
        thuật của hệ thống, trừ các trường hợp được quy định tại Khoản 3 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng
      </p>

      <p>
        Quyền truy cập dữ liệu cá nhân: Chủ thể dữ liệu có quyền truy cập dữ liệu cá nhân của mình để xem, chỉnh sửa
        hoặc yêu cầu chỉnh sửa dữ liệu cá nhân, trừ khi luật pháp có quy định khác.
      </p>

      <p>Quyền rút lại đồng ý: Chủ thể dữ liệu có quyền rút lại đồng ý của mình, trừ khi luật pháp có quy định khác.</p>

      <p>
        Quyền xóa dữ liệu cá nhân: Chủ thể dữ liệu có quyền xóa hoặc yêu cầu xóa dữ liệu cá nhân của mình, trừ khi luật
        pháp có quy định khác.
      </p>

      <p>
        Quyền hạn chế xử lý: Chủ thể dữ liệu có quyền yêu cầu hạn chế xử lý dữ liệu cá nhân của mình, trừ khi luật pháp
        có quy định khác. Việc hạn chế xử lý dữ liệu phải được thực hiện trong vòng 72 giờ sau khi nhận được yêu cầu của
        chủ thể dữ liệu, đối với tất cả dữ liệu cá nhân mà chủ thể dữ liệu yêu cầu, trừ khi luật pháp có quy định khác.
      </p>

      <p>
        Quyền nhận dữ liệu cá nhân: Chủ thể dữ liệu có quyền yêu cầu Bên Kiểm soát Dữ liệu và Bên Kiểm soát Dữ liệu kiêm
        Xử lý dữ liệu cung cấp dữ liệu cá nhân của mình, trừ khi luật pháp có quy định khác.
      </p>

      <p>Quyền phản đối xử lý:</p>

      <p>
        Chủ thể dữ liệu có quyền phản đối Bên Kiểm soát Dữ liệu và Bên Kiểm soát Dữ liệu kiêm Xử lý dữ liệu xử lý dữ
        liệu cá nhân của mình để ngăn chặn hoặc hạn chế việc tiết lộ dữ liệu cá nhân hoặc sử dụng dữ liệu cá nhân cho
        mục đích quảng cáo và tiếp thị, trừ khi luật pháp có quy định khác.
      </p>

      <p>
        Bên Kiểm soát Dữ liệu và Bên Kiểm soát Dữ liệu kiêm Xử lý dữ liệu phải tuân thủ yêu cầu của chủ thể dữ liệu
        trong vòng 72 giờ sau khi nhận được yêu cầu, trừ khi luật pháp có quy định khác.
      </p>

      <p>
        Quyền khiếu nại, tố cáo và khởi kiện: Chủ thể dữ liệu có quyền khiếu nại, tố cáo và khởi kiện theo quy định của
        pháp luật.
      </p>

      <p>
        Quyền yêu cầu bồi thường thiệt hại: Chủ thể dữ liệu có quyền yêu cầu bồi thường thiệt hại theo quy định của pháp
        luật khi có vi phạm đối với quy định về bảo vệ dữ liệu cá nhân của mình, trừ khi các bên có thỏa thuận khác hoặc
        luật pháp có quy định khác.
      </p>

      <p>
        Quyền tự bảo vệ: Chủ thể dữ liệu có quyền tự bảo vệ theo các quy định trong Bộ luật Dân sự, các luật liên quan
        khác, hoặc yêu cầu các cơ quan, tổ chức có thẩm quyền thực hiện các phương thức bảo vệ quyền dân sự theo quy
        định tại Điều 11 của Bộ luật Dân sự.
      </p>

      <p>
        <strong>2.2. Dữ liệu khách hàng và nhà cung cấp</strong>
      </p>

      <p>
        <strong>2.2.1. Xử lý dữ liệu cho mối quan hệ hợp đồng</strong>
      </p>

      <p>
        Dữ liệu cá nhân của khách hàng và nhà cung cấp (bên thứ ba) có thể được xử lý để thiết lập, thực hiện và chấm
        dứt hợp đồng. Trước khi ký hợp đồng - trong giai đoạn khởi tạo hợp đồng - dữ liệu cá nhân có thể được xử lý để
        chuẩn bị chào giá hoặc đơn đặt hàng hoặc để đáp ứng các yêu cầu khác liên quan đến việc ký kết hợp đồng. Khách
        hàng hoặc nhà cung cấp có thể được liên hệ trong quá trình chuẩn bị hợp đồng bằng cách sử dụng thông tin mà họ
        đã cung cấp. Mọi hạn chế được khách hàng hoặc nhà cung cấp yêu cầu phải được tuân thủ.
      </p>

      <p>
        ON Live TV không cần sự đồng ý của chủ thể dữ liệu để thực hiện các nghĩa vụ hợp đồng theo quy định của pháp
        luật.
      </p>

      <p>
        <strong>2.2.2. Đồng ý xử lý dữ liệu</strong>
      </p>

      <p>
        Dữ liệu có thể được xử lý sau khi có sự đồng ý của chủ thể dữ liệu. Trước khi đồng ý, chủ thể dữ liệu phải được
        thông báo theo Chính sách Bảo vệ Dữ liệu Cá nhân của công ty. Để có được sự đồng ý của chủ thể dữ liệu, các nội
        dung sau phải được thông báo cho chủ thể dữ liệu:
      </p>

      <p>a) Loại dữ liệu cá nhân sẽ được xử lý;</p>

      <p>b) Mục đích xử lý dữ liệu cá nhân;</p>

      <p>c) Các tổ chức và cá nhân có thể xử lý dữ liệu cá nhân;</p>

      <p>d) Quyền và nghĩa vụ của chủ thể dữ liệu.</p>

      <p>
        Tuyên bố đồng ý phải được lấy bằng văn bản hoặc điện tử để phục vụ mục đích lưu trữ. Trong một số trường hợp,
        như cuộc trò chuyện qua điện thoại, sự đồng ý có thể được đưa ra bằng lời nói. Việc cấp đồng ý phải được ghi
        lại.
      </p>

      <p>
        <strong>2.2.3. Xử lý dữ liệu theo ủy quyền pháp lý</strong>
      </p>

      <p>
        Việc xử lý dữ liệu cá nhân cũng được phép nếu luật quốc gia yêu cầu, đòi hỏi hoặc cho phép điều này. Loại và
        phạm vi xử lý dữ liệu phải cần thiết cho hoạt động xử lý dữ liệu được ủy quyền hợp pháp và phải tuân thủ các quy
        định pháp luật liên quan.
      </p>

      <p>
        <strong>2.2.4. Xử lý dữ liệu theo lợi ích hợp pháp</strong>
      </p>

      <p>
        Dữ liệu cá nhân cũng có thể được xử lý nếu cần thiết cho lợi ích hợp pháp của ON Live TV. Lợi ích hợp pháp
        thường mang tính chất pháp lý (ví dụ: thu hồi các khoản phải thu chưa thanh toán) hoặc thương mại (ví dụ: tránh
        vi phạm hợp đồng).
      </p>

      <p>
        Dữ liệu cá nhân không được xử lý cho các mục đích lợi ích hợp pháp nếu, trong các trường hợp cụ thể, có bằng
        chứng cho thấy lợi ích của chủ thể dữ liệu cần được bảo vệ và lợi ích đó được ưu tiên. Trước khi xử lý dữ liệu,
        cần xác định liệu có những lợi ích nào cần được bảo vệ.
      </p>

      <p>
        <strong>2.2.5. Dữ liệu người dùng và Internet</strong>
      </p>

      <p>
        Nếu dữ liệu cá nhân được thu thập, xử lý và sử dụng trên các trang web hoặc ứng dụng của ON Live TV, chủ thể dữ
        liệu phải được thông báo về việc này trong một tuyên bố bảo mật và, nếu có, thông tin về cookie. Tuyên bố bảo
        mật và bất kỳ thông tin cookie nào phải được tích hợp sao cho dễ nhận biết, dễ truy cập trực tiếp và luôn sẵn có
        cho các chủ thể dữ liệu.
      </p>

      <p>
        Nếu các hồ sơ sử dụng (theo dõi) được tạo để đánh giá việc sử dụng các trang web và ứng dụng, các chủ thể dữ
        liệu phải luôn được thông báo tương ứng trong tuyên bố bảo mật.
      </p>

      <p>
        Nếu các trang web hoặc ứng dụng có thể truy cập dữ liệu cá nhân trong khu vực hạn chế đối với người dùng đã đăng
        ký, việc xác định và xác thực chủ thể dữ liệu phải cung cấp mức độ bảo vệ đầy đủ trong quá trình truy cập.
      </p>
    </>
  )
}

export default ChinhSachBaoVeDuLieuCaNhan
